import { useBackgroundQuery, skipToken } from "@apollo/client";
import {
  getStudentPersonalDetailsQuery,
  getStudentCustomFieldConfigQuery,
  getTranscriptCommentFieldsQuery,
  getStudentTranscriptAcademicRecordsQuery,
  getTranscriptResourcesQuery,
} from "../module/AcademicRecordsQueries";
import { getOrganizationId } from "modules/CommonSelectors";

const useFetchAcademicRecordQueries = id => {
  const organizationId = getOrganizationId();
  const [personalDetailsQueryRef] = useBackgroundQuery(
    getStudentPersonalDetailsQuery,
    id
      ? {
          fetchPolicy: "cache-and-network",
          variables: { id },
        }
      : skipToken
  );

  const [customFieldConfigQueryRef] = useBackgroundQuery(
    getStudentCustomFieldConfigQuery,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        id: organizationId,
        filter: {
          names: ["STUDENT_PROFILE_CUSTOM_FIELDS_CONFIG"],
        },
      },
    }
  );

  const [commentFieldQueryRef] = useBackgroundQuery(
    getTranscriptCommentFieldsQuery,
    {
      variables: { id: organizationId },
      fetchPolicy: "cache-and-network",
      context: {
        useHttpLink: true,
      },
    }
  );

  const [academicRecordsQueryRef] = useBackgroundQuery(
    getStudentTranscriptAcademicRecordsQuery,
    id
      ? {
          variables: { id },
          fetchPolicy: "cache-and-network",
          context: {
            useHttpLink: true,
          },
        }
      : skipToken
  );

  const [transcriptResourcesQueryRef] = useBackgroundQuery(
    getTranscriptResourcesQuery,
    {
      variables: { id: organizationId },
      fetchPolicy: "cache-and-network",
      context: {
        useHttpLink: true,
      },
    }
  );

  return {
    personalDetailsQueryRef,
    customFieldConfigQueryRef,
    commentFieldQueryRef,
    academicRecordsQueryRef,
    transcriptResourcesQueryRef,
  };
};

export default useFetchAcademicRecordQueries;
